import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Validation } from "../../../../_helpers/validation/Validation";

import HeadLines from "../CommonComponents/HeadLines";
import InputText from "../CommonComponents/InputText";
import { setOTPUID, setUserInfo } from "../Redux/UserInfo/actions";
import { OtpDetails } from "./constant";
import { errorInfoIcon, PencilGreen } from "../icon_assets";

import style from "./style.module.css";
import { LoginServices } from "../../../../_services/Arya2.0/Login/LoginServices";
import { customToastr } from "../CustomToastr";
import { eventTracker } from "../GATracker3.0/eventTracker";
import {
  CHANGE_NUMBER,
  LOGIN_AFTER_OTP_FAIL,
  LOGIN_AFTER_OTP_SUCCESS,
  RESEND_OTP_VIA_CALL,
  RESEND_OTP_VIA_SMS,
} from "../GATracker3.0/constants";
import { useLocation } from "react-router";
import { isMobile } from "../helperFunc";
import eyeIcon from "./../DesktopImages/Home/eye.svg";
import darkeye from "./../DesktopImages/Home/darkeye.svg";
import eyeCutIcon from "./../DesktopImages/Home/eyeCutIcon.svg";

import Button from "../CommonComponents/Button";
const initiate = {
  otp: "",
};
const OtpVerification = (props) => {
  const dispatch = useDispatch();
  const arya_shakti_number = useSelector(
    (globalState) => globalState?.aryaShaktiMobileReducer?.arya_shakti_number
  );
  const [data, setData] = useState(initiate);
  const [showOtp, setShowOtp] = useState(false);
  const [error, setError] = useState("");
  const [disable, setDisable] = useState(true);
  const [counter, setCounter] = useState(30);
  const interval = useRef("");
  const inputRef = useRef(null);

  const location = useLocation();

  const uidData = useSelector(
    (globalState) => globalState?.userInfoReducer?.otpUid
  );

  const { setPopUpClosed = () => {} } = props;
  useEffect(() => {
    inputRef.current.focus();
  }, []);

  useEffect(() => {
    counterUpdation();

    document.querySelector(".mobile-number-entry") &&
      document
        .querySelector(".mobile-number-entry")
        .addEventListener("focus", () => {
          document.querySelector(".login-modal") &&
            document.querySelector(".login-modal").scroll(0, 1000);
        });
    return () => {
      clearInterval(interval?.current);

      document.querySelector(".mobile-number-entry") &&
        document
          .querySelector(".mobile-number-entry")
          .removeEventListener("focus", () => {
            document.querySelector(".login-modal") &&
              document.querySelector(".login-modal").scroll(0, 1000);
          });
    };
  }, []);

  useEffect(() => {
    !counter && clearInterval(interval?.current);
  }, [counter]);

  const counterUpdation = () => {
    interval.current = setInterval(() => {
      setCounter((counter) => counter - 1);
      if (counter === 1) {
        clearInterval(interval?.current);
      }
    }, 1000);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    if (value.toString().length <= 6) {
      setData((prev) => ({ ...prev, [name]: value }));
    }
    if (value.toString().length >= 6) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  };
  useEffect(() => {
    if (data.otp.toString().length === 6 && !props.isDesktop) {
      inputRef?.current?.blur();
    }
  }, [data.otp]);

  const Submit = async () => {
    let errobj = {};
    errobj = Validation(data, OtpDetails());
    setError(errobj);
    let flag = 0;
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      props.setIsLoading(true);
      let dataObj = {
        mobile: props.mobileNumber,
        otp: data.otp,
        uid: uidData?.otpUid,
      };

      let response = await LoginServices.verifyOtpByMobile(dataObj);
      let result = response;
      props.setIsLoading(false);

      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.token
      ) {
        eventTracker("event", LOGIN_AFTER_OTP_SUCCESS, {
          pagename: location.pathname === "/" ? "homepage" : location.pathname,
          phone_number: dataObj.mobile,
        });

        localStorage.setItem("authToken", result.data.data.token);
        localStorage.setItem(
          "userDashBoardData",
          JSON.stringify(result.data.data)
        );
        localStorage.setItem("parentData", JSON.stringify(result.data.data));
        localStorage.setItem("notifications", JSON.stringify(result.data.data));
        localStorage.setItem(
          "userDashBoardDataplan",
          JSON.stringify(result.data.data.userPlan)
        );
        if (
          result?.data?.data?.role_name &&
          result.data.data?.member?.roles[0].name === result.data.data.role_name
        ) {
          localStorage.setItem("isOtherUser", "isOtherUser");
        }
        localStorage.setItem(
          "disbrusementPopup",
          result.data.data.disbursementPopUp
        );
        localStorage.setItem("LacPopup", result.data.data.LacPopup);
        localStorage.setItem(
          "aryauserType",
          result.data.data.member.roles[0].id
        );
        localStorage.setItem("isKyc", result.data.data.member.kyc);
        localStorage.setItem("isParent", result.data.data.member.parent_id);
        localStorage.setItem("user_type", result.data.data.user_type);

        localStorage.setItem("rms_expire", result.data.data.rms_expire);
        localStorage.setItem("rms_token", result.data.data.rms_token);
        localStorage.setItem("rms_user", result.data.data.rms_user);
        localStorage.setItem("cookies_url", result.data.data.cookie);
        if (props.setShow) {
          props.setShow(false);
        }

        dispatch(
          setUserInfo({
            ...(result.data.data?.member || {}),
            permissions: result.data.data?.permissions,
            userData: result.data.data,
            userLoggedIn: true,
          })
        );
        if (!result.data.data.member.kyc && props.setRegShow) {
          props.setRegShow(true);
        }
        if (props.callBackFunction) {
          props.callBackFunction();
        }
        customToastr({
          text: "Login Successful",
        });
      } else {
        setError((prev) => ({
          ...prev,
          otp: response?.data?.message?.[0]
            ? response?.data?.message?.[0]
            : "Invalid Otp",
        }));
      }
      if (response?.data?.status === "error") {
        if (response?.data?.message?.[0]?.includes("expire")) {
          setPopUpClosed("expired");

          eventTracker("event", LOGIN_AFTER_OTP_FAIL, {
            pagename:
              location.pathname === "/" ? "homepage" : location.pathname,
            addinfo: "expired_otp",
          });
        } else {
          setPopUpClosed("invalid");

          eventTracker("event", LOGIN_AFTER_OTP_FAIL, {
            pagename:
              location.pathname === "/" ? "homepage" : location.pathname,
            addinfo: "invalid_otp",
          });
        }
      }
      if (!response?.data) {
        eventTracker("event", LOGIN_AFTER_OTP_FAIL, {
          pagename: location.pathname === "/" ? "homepage" : location.pathname,
          addinfo: "api_error",
        });
      }
    }
  };

  const resentOTP = async (sentType) => {
    eventTracker(
      "event",
      sentType === 1 ? RESEND_OTP_VIA_SMS : RESEND_OTP_VIA_CALL,
      {
        pagename: location.pathname === "/" ? "homepage" : location.pathname,
      }
    );

    // setLoader(true)
    let data = {
      mobile: props.mobileNumber,
      type: sentType === 1 ? "sms" : "call",
    };
    props.setIsLoading(true);

    let response = await LoginServices.resetOtp(data);
    props.setIsLoading(false);

    if (response && response.data && response.data.data) {
      //   toastr.info(response.data.data);
      setCounter(30);
      counterUpdation();
      dispatch(
        setOTPUID({
          otpUid: response.data?.data?.uid,
        })
      );

      //   setOtpsentStatus(response)
    }
    // setLoader(false);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      // Call your function here
      Submit();
    }
  };
  return (
    <>
      <div
        className={`font-weight600 
        ${
          props.isDesktop
            ? ` font-size16
        line-height19`
            : ` font-size12
        line-height14 `
        } letterSpacing025 padding-bottom12`}
      >
        <HeadLines
          className={` colorDark9 display-inline-block`}
          text={"Please enter the 6-digit OTP sent to"}
        />
        <div
          className="padding-left4 padding-right4 colorAccent4 display-inline-block cursorPointer"
          onClick={() => {
            setPopUpClosed("before");
            eventTracker("event", CHANGE_NUMBER, {
              pagename:
                location.pathname === "/" ? "homepage" : location.pathname,
            });
            if (!arya_shakti_number) props.setStepNo(0);
          }}
        >
          {" "}
          +91-<u>{props.mobileNumber}</u>
        </div>
        {!arya_shakti_number ? (
          <img
            src={PencilGreen}
            className={`cursorPointer ${
              props.isDesktop
                ? style["desktopPencilCSS"]
                : `${style["pencilCSS"]} mtb-auto `
            } `}
            onClick={() => {
              eventTracker("event", CHANGE_NUMBER, {
                pagename:
                  location.pathname === "/" ? "homepage" : location.pathname,
              });
              props.setStepNo(0);
            }}
            alt=""
          />
        ) : (
          ""
        )}
      </div>
      <div className="positionRelative">
        <img
          src={data?.otp ? (showOtp ? eyeCutIcon : darkeye) : eyeIcon}
          onClick={() => setShowOtp(!showOtp)}
          className={`${style["positionEyeCSS"]} positionAbsolute cursorPointer`}
          height={isMobile ? "20" : ""}
          width={isMobile ? "20" : ""}
          alt=""
        />
        <InputText
          className={`mobile-number-entry ${style["border-width"]} ${
            showOtp ? "" : style["pox-password"]
          } placeholderColorb8bdbd boxRadius4 lightBorder padding12   width-100 font-weight500 ${
            props.isDesktop
              ? ` font-size16
        line-height19`
              : ` font-size14
        line-height16 `
          } letterSpacing05 `}
          value={data.otp}
          onChange={onChange}
          name="otp"
          showError={error.otp}
          type="number"
          placeholder="Enter OTP"
          errorInputClassName={"input-style-error"}
          errorClassName={"input-error-style margin-top4"}
          errorIcon={errorInfoIcon}
          inputRef={inputRef}
          onKeyUp={handleKeyPress}
        />
      </div>

      {counter === 0 ? (
        <div
          className={`${style["blueColor"]} font-weight400  padding-top12
          ${
            props.isDesktop
              ? ` font-size14
          line-height16 `
              : ` font-size12
          line-height14 `
          } letterSpacing025  padding-bottom16`}
        >
          <HeadLines
            className={`  display-inline-block cursorPointer`}
            text={"Resend OTP via SMS"}
            onClick={() => resentOTP(1)}
          />
          {/* &nbsp; &nbsp;|&nbsp;&nbsp;
          <HeadLines
            className={`  display-inline-block cursorPointer cursorPointer`}
            text={"Resend OTP via Call"}
            onClick={() => resentOTP(0)}
          /> */}
        </div>
      ) : (
        <div
          className={`d-flex font-weight400  padding-top12
        ${
          props.isDesktop
            ? ` font-size14
      line-height16 `
            : ` font-size10
      line-height12 `
        } letterSpacing025 colorDark9 padding-bottom16`}
        >
          <HeadLines text={`Resend OTP?`} />
          &nbsp;&nbsp;{"00:"}
          {counter}
        </div>
      )}
      <div
        className={`font-weight400 
        ${
          props.isDesktop
            ? ` font-size14
        line-height16`
            : ` font-size10
            line-height12  `
        } letterSpacing025 padding-top16`}
      >
        <HeadLines
          className={` colorDark9 display-inline-block`}
          text={"Facing trouble while logging in? Call us on"}
        />
        <div
          className={`${style["blueColor"]} padding-left4 display-inline-block cursorPointer`}
          onClick={() => {
            window.location.href = "tel:+91-9015260260";
          }}
        >
          +91-9015260260
        </div>
      </div>
      <div className={`${style["lightBorderTop2"]}`}></div>
      <div
        className={
          props.isDesktop ? "d-flex justify-content-center padding-top4" : ""
        }
      >
        <Button
          onClick={() => {
            !disable && Submit();
          }}
          className={` ${
            !disable
              ? "backAccent3"
              : props.isDesktop
              ? style["buttonBackground"]
              : style["nonCertifiedBack"]
          } font-weight500 
        font-size14
        line-height16 letterSpacing0125 padding12 boxRadius6 textColorWhite  ${
          props.isDesktop ? ` ${style["width285"]}  ` : `width-100`
        } margin-right8 `}
          title="Verify OTP"
        />
      </div>
    </>
  );
};
export default OtpVerification;
